import type { FC, PropsWithChildren } from 'react';
import React, { createContext, useContext, useEffect, useState } from 'react';

import type { Vehicle } from 'Types/vehicle';

interface VehicleContextType {
	vehicle: Vehicle;
}

type UseVehicle = VehicleContextType['vehicle'];

type VehicleContextProviderProps = PropsWithChildren<VehicleContextType>;

const VehicleContext = createContext<Nullable<UseVehicle>>(null);
VehicleContext.displayName = 'VehicleContext';

const VehicleContextProvider: FC<VehicleContextProviderProps> = ({ children, vehicle: v }) => {
	const [vehicle, setVehicle] = useState(v);
	useEffect(() => {
		setVehicle(v);
	}, [v]);

	return <VehicleContext.Provider value={vehicle}>{children}</VehicleContext.Provider>;
};

const useVehicle = (): Vehicle => {
	const context = useContext(VehicleContext);
	if (!context) {
		throw new Error('useVehicle must be used inside VehicleContextProvider');
	}
	return context;
};

export { VehicleContextProvider, VehicleContext, useVehicle };
